import { updateAndGenerate, generate } from '../../services/generation';
import { updateBookpart, fetchBookpart } from '../../api/bookpart';
import { jsonCopy } from '@speechki-frontend/shared/helpers/functions';

import { camelCase } from 'lodash';

import { diff } from 'deep-object-diff';

const formData = (initial, bookpart) => {
    const data = diff(initial, bookpart);

    if (data.audio_generation_extra) {
        data.audio_generation_extra = bookpart.audio_generation_extra;
    }

    return data;
};

const editableFields = [
    'speed',
    'volume',
    'speaker',
    'ssml_text',
    'sound_settings',
    'emotion',
    'audio_generation_extra'
];

const createUpdatePropAction = (acc, prop) => {
    acc[camelCase(`update_${prop}`)] = (context, payload) => {
        context.commit('UPDATE_BOOKPART_PROPERTY', {
            prop,
            value: payload
        });
    };

    return acc;
};

const createUpdatePropActions = fields => {
    return fields.reduce(createUpdatePropAction, {});
};

const state = {
    bookpart: {},
    initialBookpart: {},
    changed: false,
    loading: false,

    language: null
};

const mutations = {
    SET_BOOKPART(state, bookpart) {
        state.bookpart = bookpart;
        state.initialBookpart = jsonCopy(bookpart);
        state.language = bookpart.speaker.language;
        state.changed = false;
    },
    CLEAR_BOOKPART(state) {
        state.bookpart = {};
        state.initialBookpart = {};
        state.changed = false;
        state.language = null;
    },
    UPDATE_FULL_BOOKPART(state, bookpart) {
        state.bookpart = bookpart;
        state.changed = true;
    },
    RESET_BOOKPART(state) {
        state.bookpart = jsonCopy(state.initialBookpart);
        state.language = state.initialBookpart.speaker.language;
        state.changed = false;
    },
    UPDATE_BOOKPART_PROPERTY(state, { prop, value }) {
        state.bookpart[prop] = value;
        state.changed = true;

        if (prop === 'speaker' && state.bookpart.emotion) {
            state.bookpart.emotion = null;
        }
    },
    SET_LANGUAGE(state, language) {
        state.language = language;
        state.bookpart.speaker = null;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    PLAYER_UPDATE_BOOKPART() {}
};

const getters = {};

const actions = {
    async fetchBookpart({ commit, state }, id) {
        try {
            commit('SET_LOADING', true);
            const bookpart = await fetchBookpart(id);
            if (state.bookpart.id) {
                commit('CLEAR_BOOKPART');
            }
            commit('SET_BOOKPART', bookpart);
            commit('SET_LOADING', false);
        } catch (e) {
            console.log(e);
        }
    },

    setBookpart({ commit }, bookpart) {
        commit('SET_BOOKPART', jsonCopy(bookpart));
    },

    clearBookpart({ commit }) {
        commit('CLEAR_BOOKPART', {});
    },

    async saveBookpart({ state, dispatch }) {
        const data = formData(state.initialBookpart, state.bookpart);

        await updateBookpart(state.bookpart.id, data);
        await dispatch('fetchBookpart', state.bookpart.id);
    },

    async saveAndGenerateBookpart({ dispatch, commit }) {
        const data = formData(state.initialBookpart, state.bookpart);

        if (!state.changed) await generate(state.bookpart.id);
        else await updateAndGenerate(state.bookpart.id, data);

        await dispatch('fetchBookpart', state.bookpart.id);
        commit('PLAYER_UPDATE_BOOKPART', jsonCopy(state.bookpart));
    },

    updateBookpart({ commit }, payload) {
        commit('UPDATE_FULL_BOOKPART', payload);
    },

    //
    ...createUpdatePropActions(editableFields),
    //

    resetBookpart({ commit }) {
        commit('RESET_BOOKPART');
    },

    updateLanguage({ commit }, language) {
        commit('SET_LANGUAGE', language);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
